import type { I18N } from '@vista-digital/i18n'
import type { Film } from '@vista-digital/ocapi-types/v1'
import { gtm } from '@/common/services/gtm/gtm.service'
import { CurzonEcommerceDataLayer, CurzonEcommerceItem } from '@/common/services/models-gtm'

export class FilmsGtmEvents {
    public static async viewFilmDetail(film: Film, i18n: I18N) {
        const item = new CurzonEcommerceItem({
            item_name: i18n.translatable(film.title),
            item_category: 'Film',
        })
        await gtm.sendEcommerceDataLayer(
            new CurzonEcommerceDataLayer('view_item', {
                items: [item],
            })
        )
    }
}
